import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconType, Icons } from '../../../../constants/icons';
import './WEAEntryTemplate.css';
import {
  SvgIcon,
  TextButton,
  TextButtonSize,
  TextButtonVariant,
} from '../../../Molecules';
import { getWEAProgramImage } from '../../../../constants/images';

type WEAEntryTemplateProps = {
  onClickNew: () => void;
  onClickExisting: () => void;
};

export const WEAEntryTemplate = memo(
  ({ onClickNew, onClickExisting }: WEAEntryTemplateProps) => {
    const { t } = useTranslation();
    const currentYears = new Date().getFullYear();

    return (
      <div className="WEAentry">
        <div className="centered-container">
          <img className="logoTop" src={getWEAProgramImage('img2')} />
          <p className="blue-text">{t('WEA Member Login')}</p>
          <div className="textButton1">
            <TextButton
              text={t('New User')}
              size={TextButtonSize.Large}
              variant={TextButtonVariant.WEABlue}
              onClick={onClickNew}
            />
          </div>
          <div className="textButton2">
            <TextButton
              text={t('Existing User')}
              size={TextButtonSize.Large}
              variant={TextButtonVariant.WEABlue}
              onClick={onClickExisting}
            />
          </div>
          <div className="text-copyright1">
            {t('Copyright © 2017 - {currentYear} JOYAJOY.', {
              currentYear: currentYears,
            })}
          </div>
          <div className="text-copyright2">{t('All rights reserved.')}</div>
        </div>
      </div>
    );
  },
);
